import zustand from "zustand";
import produce from "immer"
import * as THREE from "three";
import * as lodash from 'lodash';

var paramManual = require("./paramManual.json");
var paramAI     = require("./paramAI.json");

export default class Param {
  static Get(name){
    return useStoreParam(s => s[name]);
  }
  
  static toJson = (blob, callback) => {
    var reader = new FileReader();
    reader.readAsText(blob);
    reader.onload = function() {
      const json = JSON.parse(reader.result);
      callback(json);
    }
  }

  static toBlob(){
    const mes = useStoreParam(s => {
      return {'setup': s.setup,
              'align': s.align,
              'marking': s.marking,
              'baseshape': s.baseshape,
              'compress': s.compress,
              'trim1': s.trim1,
              'trim2': s.trim2,
              'trim3': s.trim3,
              'assembleAk': s.assembleAk,
              'output': s.output}
    }); // remove circular functions to stringify

    const json = JSON.stringify(mes, undefined, 2);
    const blob = new Blob([json], {
      type: "application/json"
    });
    return blob;
  }
}

const [useStoreParam] = zustand((set, get) => {
  return {
    setParam: n => set(produce(n)),
    
    setModeManual() {
      get().readFromJsonAk(paramManual);
    },
    setModeAI() {
      get().readFromJsonAk(paramAI);
    },

    setBaseshapePoints(points) {
      get().setParam(s => {s.baseshape.points.push(points)});
    },
    
    readFromJsonAk(json){
      const setLoadedJson = (k) => {
        // if there is no parameters in loaded json, set default values
        for (let item in get()[k]) {
          if (json[k][item] == undefined) {
            json[k][item] = get()[k][item];
            console.log('Missing parameter: ' + k + '.' + item + ' : ' + get()[k][item])
            console.log()
          }
        }
        get().setParam(s => {s[k] = json[k]});
      };

      setLoadedJson('setup');
      setLoadedJson('align');
      setLoadedJson('marking');
      setLoadedJson('baseshape');
      setLoadedJson('compress');
      setLoadedJson('trim1');
      setLoadedJson('trim2');
      setLoadedJson('trim3');
      setLoadedJson('assembleAk');
      setLoadedJson('output');
    },
    
    setModifyPoints(target, valueI, valueO) {
      const tmpI = get().modify.vptI.slice();
      const tmpO = get().modify.vptO.slice();
      tmpI[target] = valueI;
      tmpO[target] = valueO;
      get().setParam(s => {s.modify.vptI = tmpI, s.modify.vptO = tmpO});
    },
    setModifyPointsI(target, value) {
      const tmp = get().modify.vptI.slice();
      tmp[target] = value;
      get().setParam(s => {s.modify.vptI = tmp});
    },
    setModifyPointsO(target, value) {
      const tmp = get().modify.vptO.slice();
      tmp[target] = value;
      get().setParam(s => {s.modify.vptO = tmp});
    },
    clearModifyPoints() {
      get().setParam(s => {s.modify.vptI = [null, null, null, null, null],
                           s.modify.vptO = [null, null, null, null, null]});
    },

    oc: null, // opencascade
    resetOc: false,

    debug: false,

    // activeStep
    // 0:Setup     1:Align  2:Marking    3:Compress
    // 4:Modify    5:Trim   6:Thick      7:Joint
    // 8:Reinforth 9:Foot  10:Assemble  11:Connect
    //12:CAE
    activeStep: 0,
    showLeg: 0,
    wireLeg: false,
    showBaseShape: 0,
    exportModel: 0, // export flag to get the end date
    instructionText: "Please select Below Knee or Above Knee, and Test Socket or Final Device.",

    setup : {
      modelerVersion: process.env.REACT_APP_COMMIT_TAG,
      elapsedTimes: {},
      ai: false,
      loadParam : false,
      pathLeg: "",
      side: 0, // 0: Left 1: Right
      akModeling:0, // 0: Manual measurement 1: Scan only
      interface: 0,
      globalTranslationX: 0,
      globalTranslationY: 0,
      globalTranslationZ: 0,
      translationX: 0,
      translationY: 0,
      translationZ: 0,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      stumpLowestPoint: 0,
      greaterTrochanterAp: 0,
      greaterTrochanterSi: 0,
    },
    align : {
      step: 0,            //0:Angle 1:Set MTP 2:PTB Bar 3:Center
      degree: 5,
      rotateYaxis: 0,      // 0:view 1:yaxis

      // BK
      stepPTB: 0,         //0:Outside 1:Inside
      stepCenter: 0,      //0:Front/Back 1:Side
      vpt_ptbI: null,     //THREE.Vector3
      vpt_ptbO: null,     //THREE.Vector3
      // AK
      stumpLength: 0,
      stumpLengthAdjust: 0,
      stumpLengthX: 0,
      interval: 50,
      greaterTrochanter: null,
      legCenter: null,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      manualCircumference: 0, // for stump analysis of AK
    },
    marking : {
      target: 0,          //0:tibia_tubercle 1:tibia_candyle 2:tibia_end 3:fibura_head 4:fibura_end 5-9:User Area
      vpt: [null, null, null, null, null, null, null, null, null, null],  //THREE.Vector3 x 10 並び順はtargetと同じ

      //0:Free 1:Front 2:Back 3:Top 4:Bottom 5:Right 6:Left 7:Lock
      angle: [null, null, null, null, null, null, null, null, null, null],  
    },
    baseshape : { // only for AK
      points: [],
      bbox : null,
      idxPoint: 0,
      apDiameter : 100,
      apDiameterOutput: 0,
      ischiumCircumference: 500,
      measuredCurveLength: 0,
      compresedCurveLength: 0,
      rectusFemorisOverhang: 18,
      gluteusMaximusApAdjust: 0,
      gluteusMaximusMlAdjust: 0,
      femurShapeApAdjust: 0,
      femurShapeMlAdjust: 0,
      scaleMl: 1,
      posteriorWallLengthAdjustment: 6,
      posteriorWallAngle: 113,
      compression: 100,
      // Advance setting
      filletIschialTuberosity: 15,
      filletAdductorLongus: 15,
      filletSideWall: 60,
      filletScalpa: 150,
      adjustmentLengthPosteriorWall: -4,
      point1X: 0,
      point1Z: 7,
      point3X: 0,
      point3Z: -7,
      point4X: 0,
      point4Z: 0,
      point5X: 17,
      point5Z: 0,
      centroid: null,
    },
    compress : {
      step: 0,            //0:before apply 1:after apply
      line_no: 0,         //
      line_count: 30,     //
      interval: 20,       //
      bottomExtension: 15,      //
      offset: 5,
      compressionWhole: 100,
      radiusWhole: 0,
      compression: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
      compressionMm: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      smoothnessWhole: 5,
      smoothness: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
      //compressionIni: 100,
      //smoothnessIni: 5,
      vlines: null,      //各輪切り線の座標[[THREE.Vector3]]
      lengths: null,     //各輪切り線の長さ[]

      // AK
      points: [], // cross section points
      intervalAk: 50,
      bottomManualCircumference: 200,
      bottomRatioXY: 1,
      secondBottomManualCircumference: 300,
      secondBottomRatioXY: 1,
      bottomExtensionCurveRadius: 25,
      bottomExtensionAk: 20,
      initialAbductionAngle: 0,
      initialFlexionAngle: 5,
      manualCircumference: [260, 300, 340, 380, 420, 460, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500],
      manualOrScan: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
      tweenFactor: [0, 0, 0, 0.5, 0.8, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9],
    },
    
    trim1 : { // only for Ak
      medialTrimPoints : [
        new THREE.Vector3(0, 15, 75),
        new THREE.Vector3(0, -14, 30),
        new THREE.Vector3(0, -13, -17),
        new THREE.Vector3(0, 6, -63),
      ],
      p0X: 0,
      p0Y: 15,
      p0Z: 75,
      p1X: 0,
      p1Y: -14,
      p1Z: 30,
      p2X: 0,
      p2Y: -13,
      p2Z: -17,
      p3X: 0,
      p3Y: 6,
      p3Z: -63,
      lowerSurface: null,
    },

    trim2 : { // only for Ak
      step: -1,
      idxPoint: 0,
      idxPointTrimMl: 0,
      idxPointTrimAp: 0,
      p0X: 2,
      p0Y: 100,
      p1X: -7,
      p1Y: 50,
      p2X: -2,
      p2Y: 20,
      p3Y: 0,
      p3CenterVecAmplify: 0,
      p4Y: -10,
      p4CenterVecAmplify: 9,
      p5Y: -5,
      p5CenterVecAmplify: 4,
      p6Y: 25,
      p6Z: -3,
      p7Y: 17,
      p7Z: -10,
      p8Y: 17,
      p8Z: 0,
      p9Y: 10,
      p9Z: -15,
      p10Y: 0,
      p10Z: 0,
      p11Y: 0,
      p11Z: 0,
      p12Y: 0,
      p12Z: 0,
      p13Y: 0,
      p13Z: 0,
      ptTrimSi: null,
      ptTrimAp: null,
      ptTrimMl: null,
      trimSiRadiusMedialPosterior: 40,
      trimSiX: -11,
      trimSiZ: -10,
      trimSiBottomZ: 10,
      trimSiP0X: 40,
      trimSiP0Z: 1,
      trimSiP1X: 0,
      trimSiP1Z: 10,
      trimSiP2X: -20,
      trimSiP2Z: 10,
      trimMlP0Y: 5,
      trimMlP0Z: 100,
      trimMlP1Y: 60,
      trimMlP1Z: 26,
      trimMlP2Y: 50,
      trimMlP2Z: -60,
      trimMlP3Y: -16,
      trimMlP3Z: -95,
      trimApP0X: -40,
      trimApP0Y: -10,
      trimApP1X: -15,
      trimApP1Y: 10,
      trimApP2X: 50,
      trimApP2Y: 15,
      trimApP3X: 100,
      trimApP3Y: 30,
      trimApP4X: 150,
      trimApP4Y: 100,

      runTrimSi: false,
      runTrimAp: false,
      runTrimMl: false,
      runTrim3D: false,

      upperSurface: null,
      upperSurfaceSi: null,
      upperSurfaceMl: null,
      upperSurfaceAp: null,
      upperCurvePointsAll: null,
      upperSurfaceMesh: null,
    },

    trim3 : {
      upperSurfaceMesh: null,
    },

    assembleAk : { // only for Ak
      socketMl: 0,
      socketAp: 0,
      socketSi: 0,
      adapter: 0,
      flexionExtension: 0,
      adductionAbduction: 0,
      socketRotation: 0,
    },

    output : {
      export: false,
      step: 0,
      splitAdjust: 0,
      outputMesh: null,
      socketThickness: 5,
      socketThicknessFd: 5,
      radiusCheckHole: 15,
      intervalCheckHole: 80,
      //splitHeight: 0,
      sideHole: null,
      engraving: -1,
    },



    modify : {
      mode: 0,            //0:ADD 1:DEL
      step: 0,            //0:before apply 1:after apply
      target: 0,          //0:ptb 1:counter 2:tibia 3:fibura_head 4:fibura_end 5-9:User Area
      //以下の配列数=10はtargetと対応している
      vptI: [null, null, null, null, null, null, null, null, null, null],  //[THREE.Vector3]
      vptO: [null, null, null, null, null, null, null, null, null, null],  //[THREE.Vector3]
      smooth: [5, 5, 5, 5, 5, 0, 0, 0, 0, 0],
      depth: [-8, -3, 3, 3, 3, 0, 0, 0, 0, 0], // default value
      depthNow: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // current value
      //uneven: [-1, -1, 1, 1, 1, 1, 1, 1, 1, 1],    // -1:pull  1:push
      executeSmooth: 0,
      iterationSmooth: 1,
    },
    trim : {
      step: 0,          //0:2D 1:3D 2:Trimmed 3:Bended
      mode: 0,          //0:ADD 1:DEL
      outer_thickness: 3.0,
      smooth: 6,
      curveWidth: 15,
      curveAngle: 135,
      curveR: 4,
      curveRange: 40,
      nTrimPointsMod: 300,
      vpt2D: null,      // [THREE.Vector3]
      vpt3D: null,  
    },
    thick : {
      step: 0,          //0:before apply 1:after apply
      outerThickness: 3.0,
      smooth: 6,
      flexionAngle: 0,
      connector: 0,
      apConnector: 0,
      mlConnector: 0,
      boundaryCurveIndex: 0,
      maxBoundaryCurveIndex: 1,
    },
    outputBk : {
      step: 0,          //0:before apply 1:after apply
      reinforcementTopEdgeThickness: 3,
      reinforcementTopEdgeWidth: 15,
      reinforcementWeaknestAreaThickness: 2,
      reinforcementWeaknestAreaWidth: 60,
    },
    reinforth : {
      step: 0,          //0:before apply 1:after apply
      inner_thickness: 1.5,
      outer_thickness: 3.0,
      reinforth_thickness: 1.5,
      reinforth_width: 15,
      smooth: 6,
    },
    foot : {
      heel_height: "0",    //0 / 1 / 3
      foot_size: 24,
      sole_type: "normal",  // normal / slit / slit_stopper
    },
    assemble : {
      step: "0",
      length: 40,
      flex_angle: 0,
      pos_front_back: 0,
      adduct_angle: 0,
      pos_in_out: 0,
      angle_in_out: 0,
      angle_up_down: 0,
    },
    connection : {
      step: 0,
      smooth: 5,
      mode: "Shaping",        // Shaping / Picture
      modePt: 0,              // 0:ADD 1:DEL
      target: "Front",        // Front / Back / Left / Right / All
      //vptF: null,             //[THREE.Vector3]
      //vptB: null,             //[THREE.Vector3]
      //vptL: null,             //[THREE.Vector3]
      //vptR: null,             //[THREE.Vector3]
      picture_view: "Front",  // Front / Side
      picture_mode: "Move",   // Move / Scale / Rotate
    },


    finalDeviceFinalStep : {
      rotation_center_from_the_end_of_socket: 62.6,
      flexion_extension: 0,
      adduction_abduction: 0,
      toeout_toein: 0,
      trans_x: 0,
      trans_y: 0,

      max_height_4hole: 35,
      cull_index_of_4hole: -1,
      bending_holes: 0,
      hexagon0: 0,
      hexagon1: 0,
      hexagon2: 0,
      hexagon3: 0,

      center_hole_disable: 1,
      outer_ring_hole: 1,
    },

    softInsert : {
      topLineHeight: 150,
      bottomLineHeight: 100,
      offsetToBottom: -60,
    }
  };
});
